export enum TimeUnit {
    Hour = 'Hour',
    // eslint-disable-next-line
    Day = 'Day',
    Month = 'Month',
}
